import cardModuleMutations from "./cardModule/mutations";

export default {
  ...cardModuleMutations,
};
